export function parseLocation(location) {
  let city = null;
  let state = null;
  if (location) {
    const index = location.lastIndexOf(',');
    city = location.substring(0, index);
    state = location.substring(index + 2, location.length);
  }
  return { city, state };
}

export function toLocationDisplayValue(locationCity, locationState) {
  return locationCity && locationState ? `${locationCity}, ${locationState}` : null;
}
